
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roteiros",
      function () {
        return require("private-next-pages/roteiros/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roteiros"])
      });
    }
  